import { PartialTranslation } from '../translations';

export const el: PartialTranslation = {
  newChat: 'Νέα συνομιλία',
  search: 'Αναζήτηση',
  user: 'Χρήστης',
  settings: 'Ρυθμίσεις',
  language: 'Γλώσσα',
  getHelp: 'Λήψη βοήθειας',
  viewAllPlans: 'Προβολή όλων των πλάνων',
  learnMore: 'Μάθετε περισσότερα',
  logOut: 'Αποσύνδεση',
  chooseLanguage: 'Επιλογή γλώσσας',
  chooseYourPreferredLanguage: 'Επιλέξτε την προτιμώμενη γλώσσα σας',
  searchLanguages: 'Αναζήτηση γλωσσών...',
  autoDetect: 'Αυτόματη ανίχνευση',
  noLanguagesFound: 'Δεν βρέθηκαν γλώσσες',
  askAnything: 'Ρωτήστε οτιδήποτε',
  lawhelperAi: 'Lawhelper.ai',
  personal: 'Προσωπικό',
  freePlan: 'Δωρεάν πλάνο',
  current: 'Τρέχον',
  close: 'Κλείσιμο',
  archive: 'Αρχειοθέτηση',
  delete: 'Διαγραφή',
  confirmDelete: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτή τη συνομιλία;',
  confirmArchive: 'Είστε βέβαιοι ότι θέλετε να αρχειοθετήσετε αυτή τη συνομιλία;',
  deleteCannotUndo: 'Αυτή η ενέργεια δεν μπορεί να αναιρεθεί.',
  archiveCanFind: 'Μπορείτε να τη βρείτε στη λίστα αρχείων μετά την αρχειοθέτηση.',

  // 资源面板
  resources: 'Πόροι',
  addResource: 'Προσθήκη πόρου',
  deleteResource: 'Διαγραφή πόρου',
  noMatchingResourcesFound: 'Δεν βρέθηκαν ταιριαστοί πόροι',
  noResourcesAvailable: 'Δεν υπάρχουν διαθέσιμοι πόροι',
  hideResources: 'Απόκρυψη πόρων',
  showResources: 'Εμφάνιση πόρων',

  // 聊天输入框
  typeMessage: 'Πληκτρολογήστε ένα μήνυμα...',
  thinkingOptions: 'Επιλογές σκέψης',
  deleteFile: 'Διαγραφή αρχείου',
  clearSelection: 'Εκκαθάριση επιλογής',
  addAttachment: 'Προσθήκη συνημμένου',
  sendMessage: 'Αποστολή μηνύματος',

  // 思考模式选项
  deepInsight: 'Βαθιά διορατικότητα · Επιφανειακή ανάλυση',
  deepInsightDesc: 'Γρήγορη κατανόηση των κλειδιών σημείων',
  deepExploration: 'Βαθιά εξερεύνηση · Ολοκληρωμένη ανάλυση',
  deepExplorationDesc: 'Πολυδιάστατη εις βάθος έρευνα',
  deepDeconstruction: 'Βαθιά αποδόμηση · Συστηματικό επιχείρημα',
  deepDeconstructionDesc: 'Στρώμα προς στρώμα προοδευτική ανάλυση',

  // 写作模式选项
  contractReview: 'Επισκόπηση συμβολαίου · Αναγνώριση κινδύνων',
  contractReviewDesc: 'Ανάλυση όρων και έλεγχος συμμόρφωσης',
  textPolish: 'Βελτίωση κειμένου · Επαγγελματική έκφραση',
  textPolishDesc: 'Βελτιστοποίηση γλώσσας και δομική προσαρμογή',
  legalDocuments: 'Νομικά έγγραφα · Τυπικό προσχέδιο',
  legalDocumentsDesc: 'Επαγγελματική συγγραφή νομικών εγγράφων',

  // 认证和隐私翻译 (English fallback - needs translation)
  login: 'Σύνδεση',
  register: 'Εγγραφή',
  welcomeBack: 'Καλώς ήρθατε στο LawHelper',
  loginSubtitle: 'Ο AI Νομικός Ερευνητικός Βοηθός σας',
  continueWithGoogle: 'Συνέχεια με Google',
  continueWithMicrosoft: 'Συνέχεια με Microsoft',
  continueWithWeChat: 'Συνέχεια με WeChat',
  orContinueWith: 'ή συνεχίστε με',
  emailTab: 'Email',
  phoneTab: 'Τηλέφωνο',
  emailPlaceholder: 'Εισάγετε το email σας',
  phonePlaceholder: 'Εισάγετε αριθμό τηλεφώνου',
  codePlaceholder: 'Εισάγετε 6ψήφιο κωδικό',
  sending: 'Αποστολή...',
  verifying: 'Επαλήθευση...',
  verify: 'Επαλήθευση',
  sendMagicLink: 'Αποστολή μαγικού συνδέσμου',
  getVerificationCode: 'Λήψη κωδικού',
  resendCode: 'Επαναποστολή κωδικού',
  resendIn: 'Επαναποστολή σε',
  magicLinkSent: 'Ο μαγικός σύνδεσμος στάλθηκε στο email σας',
  magicLinkHint: 'Θα σας στείλουμε έναν ασφαλή σύνδεσμο στο email σας',
  otpSent: 'Ο κωδικός επαλήθευσης στάλθηκε',
  agreeToTerms: 'Συνεχίζοντας, συμφωνείτε με τους',
  privacyPolicy: 'Πολιτική Απορρήτου',
  termsOfService: 'Όροι Χρήσης',
  and: 'και',

  // AI工具面板
  aiReview: 'Έλεγχος AI',
  aiDraft: 'Σύνταξη AI',
  smartAssistant: 'Πρότυπο',

  // 知识库搜索
  enableKnowledgeSearch: 'Ενεργοποίηση αναζήτησης γνώσεων',
  knowledgeSearchDesc: 'Το AI δίνει προτεραιότητα στην αναζήτηση από τα έγγραφά σας',
  clickToDisable: 'Κλικ για απενεργοποίηση',
  clickToEnable: 'Κλικ για ενεργοποίηση',

  privacyTitle: 'Το απόρρητό σας έχει σημασία',
  privacyIntro: 'Χρησιμοποιούμε cookies και παρόμοιες τεχνολογίες για να σας προσφέρουμε την καλύτερη εμπειρία.',
  essentialCookies: 'Απαραίτητα cookies',
  essentialDesc: 'Απαιτούνται για τη λειτουργία του ιστότοπου',
  analyticsCookies: 'Cookies ανάλυσης',
  analyticsDesc: 'Μας βοηθούν να βελτιώσουμε την υπηρεσία μας',
  marketingCookies: 'Cookies μάρκετινγκ',
  marketingDesc: 'Χρησιμοποιούνται για εξατομικευμένο περιεχόμενο',
  acceptAll: 'Αποδοχή όλων',
  essentialOnly: 'Μόνο απαραίτητα',
  customize: 'Προσαρμογή',
  savePreferences: 'Αποθήκευση προτιμήσεων',
  back: 'Πίσω',
  readPrivacyPolicy: 'Διαβάστε την πολιτική απορρήτου μας',
  cookiePolicy: 'Πολιτική cookies',
  gdprCompliance: 'GDPR',
  piplCompliance: 'PIPL',

  // Landing page translations
  tagline: 'AI-Powered Legal Intelligence',
  heroTitle1: 'Legal AI',
  heroTitle2: 'Simplified.',
  jurisdictionsLabel: 'Jurisdictions',
  accuracyLabel: 'Accuracy',
  fasterLabel: 'Faster',
  availableLabel: 'Available',
  platformCapabilities: 'Platform Capabilities',
  testimonialQuote: '"LawHelper has transformed how we handle legal work. Contract review is 10x faster, with incredible accuracy."',
  testimonialAuthor: 'Legal Professional',
  testimonialPosition: 'Partner at Top Law Firm',
  viewPricing: 'View Pricing',
  footerPricing: 'Pricing',
  footerPrivacy: 'Privacy',
  footerTerms: 'Terms',
  footerContact: 'Contact',
  footerCopyright: '© 2024 LawHelper. All rights reserved.',

  // Onboarding Guide
  onboardingWelcome: 'Welcome to Lawhelper.ai',
  onboardingSkip: 'Skip',
  onboardingNext: 'Next',
  onboardingPrev: 'Back',
  onboardingGetStarted: 'Get Started',
  onboardingSlide1Title: 'AI Legal Chat',
  onboardingSlide1Desc: 'Ask any legal question and get precise, jurisdiction-aware answers powered by advanced AI.',
  onboardingSlide2Title: 'Case Folder System',
  onboardingSlide2Desc: 'Organize your documents by case. Upload files and control which materials AI uses as context.',
  onboardingSlide3Title: 'Local Folder Access',
  onboardingSlide3Desc: 'Connect local directories in the browser. Preview, edit, and send files to AI chat.',
  onboardingSlide4Title: 'AI Drafting & Review',
  onboardingSlide4Desc: 'Draft legal documents with AI and review contracts to identify risks automatically.',
  onboardingGuide: 'Guide',
  mentionFiles: "Reference a file",

  // Auto-synced keys
  chats: 'Chats',
  archived: 'Archived',
  restore: 'Restore',
  noArchivedChats: 'No archived chats',
  backToChats: 'Back to Chats',
  closeResourcesPanel: 'Κλείσιμο πίνακα πόρων',
  uploading: 'Μεταφόρτωση %{fileName}...',
  processing: 'Επεξεργασία %{fileName}...',
  uploadSuccess: '✓ %{fileName} μεταφορτώθηκε',
  uploadError: '✗ Αποτυχία μεταφόρτωσης: %{error}',
  quickAnswer: 'Γρήγορη απάντηση',
  quickAnswerDesc: 'Γρήγορη απάντηση σε απλές ερωτήσεις',
  cancelRequest: 'Ακύρωση',
  library: 'Βιβλιοθήκη',
  filterAll: 'Όλα',
  filterChat: 'Συνομιλίες',
  filterReview: 'Έλεγχος',
  filterDraft: 'Προσχέδιο',
  filterTemplate: 'Πρότυπο',
  filterForm: 'Φόρμα',
  thinking: 'Σκέφτομαι...',
  thinkingProcess: 'Διαδικασία σκέψης',
  analyzingLegalLogic: 'Ανάλυση νομικής λογικής...',
  lawhelperThinking: 'Το Lawhelper σκέφτεται...',
  serviceError: 'Σφάλμα υπηρεσίας',
  uploaded: 'Μεταφορτώθηκε',
  settingsGeneral: 'Γενικά',
  settingsNotifications: 'Ειδοποιήσεις',
  settingsAppearance: 'Εμφάνιση',
  settingsProfile: 'Προφίλ',
  settingsResponseNotifications: 'Ειδοποιήσεις απαντήσεων',
  settingsResponseNotificationsDesc: 'Ειδοποίηση όταν ολοκληρωθεί η απάντηση AI',
  settingsColorMode: 'Λειτουργία χρώματος',
  settingsLight: 'Φωτεινό',
  settingsDark: 'Σκοτεινό',
  settingsSystem: 'Σύστημα',
  about: 'Σχετικά',
  reviewTitle: 'Έλεγχος εγγράφου',
  exitReview: 'Έξοδος από έλεγχο',
  uploadPrompt: 'Ανεβάστε PDF για έλεγχο',
  uploadButton: 'Επιλογή αρχείου',
  startChatConfig: 'Πληκτρολογήστε "Ελέγξτε αυτό το έγγραφο"',
  reviewPlaceholder: 'Πληκτρολογήστε μήνυμα...',
  analyzing: 'Έλεγχος...',
  reviewComplete: 'Ο έλεγχος ολοκληρώθηκε',
  issuesFound: 'Βρέθηκαν %{count} προβλήματα',
  draftTitle: 'Σύνταξη νομικού εγγράφου',
  draftPlaceholder: 'Επεξεργαστείτε εδώ ή ζητήστε από το AI...',
  analyzingTemplate: 'Ανάλυση προτύπου %{name}...',
  templateAnalyzed: '✅ Πρότυπο %{name} αναλύθηκε!',
  templateAnalysisPrompt: 'Ανάλυση βασικών ρητρών',
  parsingFailed: '⚠️ Αποτυχία ανάλυσης αρχείου.',
  generating: 'Δημιουργία...',
  generatedSuccess: '✅ Το έγγραφο δημιουργήθηκε!',
  drafterWelcome: 'Καλώς ήρθατε στον Βοηθό Εγγράφων AI',
  drafterYouCan: 'Μπορείτε:',
  drafterUploadTemplate: 'Να ανεβάσετε πρότυπο για ανάλυση',
  drafterDescribeNeeds: 'Να περιγράψετε τις απαιτήσεις',
  drafterLetAiHelp: 'Το AI βοηθά με συμβάσεις, συμφωνίες κλπ.',
  drafterExamples: 'Παραδείγματα:',
  drafterExampleRental: '"Συντάξτε σύμβαση ενοικίασης"',
  drafterExampleLabor: '"Συμπληρώστε τη σύμβαση εργασίας"',
  drafterInputPlaceholder: 'Περιγράψτε τις ανάγκες σας...',
  drafterThinking: 'Σκέφτομαι...',
  drafterHistoryTitle: 'Ιστορικό',
  drafterNoHistory: 'Χωρίς ιστορικό',
  drafterNewChat: 'Νέα συνομιλία',
  drafterHistory: 'Ιστορικό',
  drafterRemoveAttachment: 'Αφαίρεση συνημμένου',
  drafterLineHeight: 'Ύψος γραμμής',
  drafterLineHeightSuffix: 'x',
  drafterExportWord: 'Εξαγωγή ως Word (.docx)',
  drafterExportPdf: 'Εξαγωγή ως PDF',
  drafterSave: 'Αποθήκευση εγγράφου',
  drafterDownload: 'Λήψη εγγράφου',
  drafterUndo: 'Αναίρεση',
  drafterRedo: 'Επανάληψη',
  drafterBold: 'Έντονα',
  drafterItalic: 'Πλάγια',
  drafterStrike: 'Διαγραμμένα',
  drafterUnderline: 'Υπογράμμιση',
  drafterHighlight: 'Επισήμανση',
  drafterLink: 'Εισαγωγή συνδέσμου',
  drafterAlignLeft: 'Αριστερά',
  drafterAlignCenter: 'Κέντρο',
  drafterAlignRight: 'Δεξιά',
  drafterAlignJustify: 'Πλήρης στοίχιση',
  drafterList: 'Λίστα',
  drafterBulletList: 'Κουκκίδες',
  drafterOrderedList: 'Αριθμημένη λίστα',
  drafterTaskList: 'Λίστα εργασιών',
  drafterOpenResource: 'Άνοιγμα πόρων',
  drafterStopGeneration: 'Διακοπή δημιουργίας',
  drafterAgentMode: 'Λειτουργία πράκτορα ενεργή',
  drafterAgentModeOn: 'Λειτουργία πράκτορα ενεργή',
  drafterAgentModeOff: 'Κανονική λειτουργία',
  drafterUploadAttachment: 'Ανέβασμα συνημμένου',
  drafterExit: 'Έξοδος',
  drafterConfirm: 'Επιβεβαίωση',
  drafterOpenLink: 'Άνοιγμα συνδέσμου',
  drafterDeleteLink: 'Διαγραφή συνδέσμου',
  drafterQuote: 'Παράθεση',
  workflowTitle: 'Ροή εργασίας AI',
  workflowRunning: 'Εκτελείται...',
  workflowReady: 'Έτοιμο',
  workflowCompleted: 'Ολοκληρώθηκε',
  workflowStartFailed: 'Αποτυχία εκκίνησης',
  workflowExecutionFailed: 'Αποτυχία εκτέλεσης',
  workflowInterrupted: 'Η ροή διακόπηκε',
  workflowProcessing: 'Επεξεργασία...',
  workflowStepsCompleted: 'βήματα ολοκληρώθηκαν',
  workflowStepsTotal: 'Ροή ολοκληρώθηκε (%{count} βήματα)',
  acceptChanges: 'Αποδοχή αλλαγών',
  rejectChanges: 'Απόρριψη αλλαγών',
  changesAccepted: 'Αλλαγές αποδεκτές',
  changesRejected: 'Αλλαγές απορρίφθηκαν',
  stopWorkflow: 'Διακοπή',
  restartWorkflow: 'Επανεκκίνηση',
  startDrafting: 'Έναρξη σύνταξης',
  interrupt: 'Διακοπή',
  documentSubject: 'Θέμα εγγράφου *',
  documentType: 'Τύπος εγγράφου',
  jurisdiction: 'Δικαιοδοσία',
  specialRequirements: 'Ειδικές απαιτήσεις (προαιρετικό)',
  clickStartDrafting: 'Κάντε κλικ "Έναρξη σύνταξης"',
  docTypeContract: 'Σύμβαση',
  docTypeAgreement: 'Συμφωνία',
  docTypeNotice: 'Ειδοποίηση',
  docTypeLetter: 'Επιστολή',
  docTypePetition: 'Αίτηση',
  docTypeWill: 'Διαθήκη',
  docTypePowerOfAttorney: 'Πληρεξούσιο',
  countryChina: 'Κίνα',
  countryUSA: 'ΗΠΑ',
  countryGermany: 'Γερμανία',
  countryJapan: 'Ιαπωνία',
  countryFrance: 'Γαλλία',
  countryUK: 'Ηνωμένο Βασίλειο',
  citationVerified: 'Επαληθευμένο',
  citationUnverified: 'Μη επαληθευμένο',
  imageLoadFailed: 'Αποτυχία φόρτωσης εικόνας',
  smartDocTitle: 'Έξυπνος βοηθός εγγράφων',
  smartDocChatTitle: 'Βοηθός εγγράφων AI',
  smartDocDropPrompt: 'Αφήστε PDF εδώ',
  smartDocSelectFile: 'Επιλογή αρχείου',
  smartDocOr: 'ή',
  smartDocWelcomeTitle: 'Καλώς ήρθατε στον Βοηθό AI',
  smartDocWelcomeYouCan: 'Μπορείτε:',
  smartDocUploadForAI: 'Ανεβάστε πρότυπο',
  smartDocDescribeDoc: 'Περιγράψτε απαιτήσεις',
  smartDocLetAIDraft: 'Το AI βοηθά με συμβάσεις',
  smartDocExamples: 'Παραδείγματα:',
  smartDocExampleRental: '"Συντάξτε σύμβαση ενοικίασης"',
  smartDocExampleLabor: '"Συμπληρώστε σύμβαση εργασίας"',
  smartDocInputPlaceholder: 'Περιγράψτε ανάγκες...',
  smartDocRemoveAttachment: 'Αφαίρεση συνημμένου',
  smartDocOpenResources: 'Άνοιγμα πόρων',
  smartDocExit: 'Έξοδος',
  reviewStartFailed: 'Αποτυχία εκκίνησης ελέγχου',
  reviewFailed: 'Ο έλεγχος απέτυχε',
  reviewFoundIssues: 'Έλεγχος ολοκληρώθηκε, %{count} προβλήματα.',
  cannotReadStream: 'Αδυναμία ανάγνωσης ροής',
  parseEventFailed: 'Αποτυχία ανάλυσης συμβάντος',
  errorPrefix: 'Σφάλμα',
  unknownError: 'Άγνωστο σφάλμα',
  file: 'Αρχείο',
  loading: 'Φόρτωση...',
  localFolders: 'Τοπικοί φάκελοι',
  selectLocalFolder: 'Επιλογή τοπικού φακέλου',
  reselectFolder: 'Αλλαγή φακέλου',
  addToContext: 'Προσθήκη στη συνομιλία',
  saveFile: 'Αποθήκευση',
  renameFile: 'Μετονομασία',
  fileSaved: 'Αρχείο αποθηκεύτηκε',
  fileRenamed: 'Αρχείο μετονομάστηκε σε %{name}',
  browserNotSupported: 'Ο φυλλομετρητής δεν υποστηρίζει πρόσβαση φακέλων',
  noFolderSelected: 'Επιλέξτε τοπικό φάκελο',
  scanningFolder: 'Σάρωση φακέλου...',
  selectFileToPreview: 'Επιλέξτε αρχείο για προεπισκόπηση',
  aiAnalyze: 'Ανάλυση AI',
};
